import React from 'react';
import { useTranslations } from '../../localization/useTranslations';
import Icon from '../../common/components/Icon';
import { AuthFormStage } from '../types/Auth';

interface AuthenticationHeaderProps {
  stage?: AuthFormStage;
  isPasswordResetPage?: boolean;
}

const AuthenticationHeader: React.FC<AuthenticationHeaderProps> = ({ stage, isPasswordResetPage }) => {
  const translations = useTranslations();

  const getTitle = () => {
    if (isPasswordResetPage) {
      return translations?.authTitles?.setANewPassword || 'Set a new password';
    }

    switch (stage) {
      case 'email':
        return translations?.authTitles?.loginOrCreateAnAccount || 'Login or Create an Account';
      case 'password':
        return translations?.authTitles?.welcomeBackEnterYourPassword || 'Welcome back! Enter your password';
      case 'register':
        return translations?.authTitles?.loginOrCreateAnAccount || 'Login or Create an Account';
      case 'resetPassword':
        return (
          translations?.authTitles?.afterResetPasswordYouWillReceiveEmail ||
          'After resetting your password, you will receive a password reset link via email'
        );
      case 'resetRequestSent':
        return (
          translations?.authTitles?.weHaveSentALinkToResetYourPassword ||
          'We have sent a password reset link to your email'
        );
      default:
        return translations?.authTitles?.loginOrCreateAnAccount || 'Login or Create an Account';
    }
  };

  return (
    <div className="authentication__header">
      <div className="header__account">
        <Icon name="fsquare" size="large" />
        <h3>{translations?.myAccountSettings?.account || 'Account'}</h3>
      </div>

      <h4 className="heading">{getTitle()}</h4>
    </div>
  );
};

export default AuthenticationHeader;
